import { render, staticRenderFns } from "./CustomerCenterPage.vue?vue&type=template&id=2f692d20"
import script from "./CustomerCenterPage.vue?vue&type=script&lang=js"
export * from "./CustomerCenterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports